import CreditCardPage from "./CreditCardPage";

export default [
    {
        path: "/credit-card",
        name: "credit-card",
        component: CreditCardPage
    }
];